<template>
  <div class="table">
    <div class="table_header">
      <slot name="header"></slot>
    </div>
    <div class="table_list">
      <el-table
        v-loading="loading"
        :data="tableList"
        style="width: 100%"
        size="small"
        border
        @selection-change="handleSelectionChange"
        class="equipment-table"
      >
        <el-table-column v-if="showSelect" type="selection" width="55">
        </el-table-column>
        <template v-for="item in tableOptionList">
          <el-table-column
            v-if="item.slotName"
            :key="item.porp"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            v-bind="item.other"
          >
            <template slot-scope="scope">
              <slot :name="item.slotName" :row="scope.row"></slot>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :key="item.porp"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            v-bind="item.other"
          >
          </el-table-column>
        </template>
      </el-table>
    </div>

    <div class="table_footer" v-if="showFooter">
      <slot name="footer">
        <el-pagination
          :current-page="currentPage"
          :page-size="pageSize"
          :layout="layout"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableList: {
      type: Array,
      default: () => []
    },
    tableOptionList: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    showSelect: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 15
    },
    total: {
      type: Number,
      default: 0
    },
    layout: {
      type: String,
      default: "total, prev, pager, next, jumper"
    }
  },
  data() {
    return {};
  },
  methods: {
    handleSelectionChange(selection) {
      this.$emit("selection-change", selection);
    },
    handleCurrentChange(val) {
      this.$emit("current-change", val);
    },
    handleSizeChange(val) {
      this.$emit("size-change", val);
    }
  }
};
</script>

<style lang="scss" scoped>


.equipment-table {
      width: 96%;
      margin: 0 auto;
      background-color: rgba(0, 0, 0, 0);
      &::before {
        display: none;
      }
 
      tbody tr:hover > td {
        background-color: #231994 !important;
      }
 
      //修改表头
      .el-table__header-wrapper {
        th {
          background-color: #231994;
          font-size: 1vw;
          font-weight: 400;
          color: #1bd9f3;
          border-right: 1px solid rgba(255, 255, 255, 0.15);
 
          &.is-leaf {
            border-bottom: 3px solid #245ab0;
            text-align: center;
          }
        }
      }
 
       //修改表格内容
      .el-table__body-wrapper {
        tr {
          td {
            background-color: #2a1d78;
            border-bottom: none;
            border-right: 1px solid rgba(255, 255, 255, 0.15);
            font-size: 0.8vw;
            font-weight: 400;
            color: #fff;
            padding-left: 0.5vw;
          }
 
          &.el-table__row--striped {
            td {
              background-color: #221d83;
            }
          }
        }
      }
 
      .el-table__empty-block {
        background-color: #19396b;
 
        .el-table__empty-text {
          color: #fff;
          font-weight: 400;
          font-size: 0.8vw;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/table/Table.vue